(function () {
    var STORAGE_KEY = "onetrust-accept";
    var SESSION_KEY = "onetrust-banner-dismissed-session";
    var HTML_CLASS = "onetrust-banner-dismissed";
    var oneTrustCloseCalled = false;

    function hasOneTrustCookies() {
        return (
            /(?:^|;\s*)OptanonConsent=/.test(document.cookie) ||
            /(?:^|;\s*)OptanonAlertBoxClosed=/.test(document.cookie)
        );
    }

    function shouldHideBanner() {
        try {
            if (localStorage.getItem(STORAGE_KEY) === "true") return true;
            if (sessionStorage.getItem(SESSION_KEY) === "1") return true;
        } catch (e) {}
        return hasOneTrustCookies();
    }

    function clearStuckOverlay() {
        var filter = document.querySelector(".onetrust-pc-dark-filter");
        var pc = document.getElementById("onetrust-pc-sdk");

        [filter, pc].forEach(function (el) {
            if (!el) return;
            el.classList.add("ot-hide");
            el.style.display = "none";
            el.style.visibility = "hidden";
            el.style.opacity = "0";
            el.style.pointerEvents = "none";
            el.setAttribute("aria-hidden", "true");
        });

        document.documentElement.classList.remove("ot-no-scroll");
        document.body.classList.remove("ot-no-scroll");
    }

    function applyBannerDismissed() {
        if (!shouldHideBanner()) return;

        document.documentElement.classList.add(HTML_CLASS);
        clearStuckOverlay();

        if (
            !oneTrustCloseCalled &&
            window.OneTrust &&
            typeof window.OneTrust.Close === "function"
        ) {
            oneTrustCloseCalled = true;
            try {
                window.OneTrust.Close();
            } catch (e) {}
        }
    }

    function markAccepted() {
        try {
            localStorage.setItem(STORAGE_KEY, "true");
        } catch (e) {}

        try {
            window.dispatchEvent(new CustomEvent("dbodhi-onetrust-accepted"));
        } catch (e) {}

        applyBannerDismissed();
        setTimeout(applyBannerDismissed, 400);
        setTimeout(applyBannerDismissed, 1500);
    }

    function markClosedForSession() {
        try {
            sessionStorage.setItem(SESSION_KEY, "1");
        } catch (e) {}

        applyBannerDismissed();
        setTimeout(applyBannerDismissed, 400);
    }

    function syncFromCookies() {
        if (hasOneTrustCookies()) {
            try {
                localStorage.setItem(STORAGE_KEY, "true");
            } catch (e) {}
        }
    }

    document.addEventListener("click", function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        if (
            target.closest(
                "#onetrust-accept-btn-handler, #accept-recommended-btn-handler, .save-preference-btn-handler",
            )
        ) {
            markAccepted();
            return;
        }

        if (
            target.closest(
                "#onetrust-reject-all-handler, #close-pc-btn-handler, .onetrust-close-btn-handler",
            )
        ) {
            markClosedForSession();
        }
    });

    syncFromCookies();
    applyBannerDismissed();

    [500, 1500, 3000, 6000].forEach(function (ms) {
        setTimeout(function () {
            syncFromCookies();
            applyBannerDismissed();
        }, ms);
    });
})();
